"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.removeSpecificCharactersFromString = void 0;
var removeSpecificCharactersFromString = function removeSpecificCharactersFromString(_ref) {
  var _ref$string = _ref.string,
    string = _ref$string === void 0 ? "" : _ref$string,
    _ref$removeSpaces = _ref.removeSpaces,
    removeSpaces = _ref$removeSpaces === void 0 ? false : _ref$removeSpaces,
    _ref$spaceChar = _ref.spaceChar,
    spaceChar = _ref$spaceChar === void 0 ? "_" : _ref$spaceChar;
  if (!string) return "";
  var stringWithoutSpecificChars = string.replace(/--/g, "-").replace(/ą/g, "a").replace(/Ą/g, "A").replace(/ć/g, "c").replace(/Ć/g, "C").replace(/ę/g, "e").replace(/Ę/g, "E").replace(/ł/g, "l").replace(/Ł/g, "L").replace(/ń/g, "n").replace(/Ń/g, "N").replace(/ó/g, "o").replace(/Ó/g, "O").replace(/ś/g, "s").replace(/Ś/g, "S").replace(/ż/g, "z").replace(/Ż/g, "Z").replace(/ź/g, "z").replace(/Ź/g, "Z");
  if (!removeSpaces) {
    return stringWithoutSpecificChars;
  }
  return stringWithoutSpecificChars.replace(/\s/g, spaceChar);
};
exports.removeSpecificCharactersFromString = removeSpecificCharactersFromString;
var _default = removeSpecificCharactersFromString;
exports["default"] = _default;